export const languages = ['en', 'fr'] as const
export type AvailableLanguages = (typeof languages)[number]
